import styled, { keyframes } from 'styled-components';

import arrowsMenu from '../../../public/images/arrows-menu.jpg';
import RouterLink from 'redux-first-router-link';


export const Menu = styled.div`
  &::before {
    content: '';
    position: absolute;
    z-index: -1;

    width: 400%;
    height: 400%;

    background-color: ${({ bgColor }) => bgColor};
    background-image: ${({ background }) => `url(${background.image})`};
    will-change: background;
    background-repeat: repeat;
    background-size: 30%;
    transform: ${({ background }) => `rotate(${background.direction}deg) translateZ(0)`};

    animation-duration: ${({ background }) => `${background.speed}s`};

    @media (min-width: 768px) {
      background-size: 9%;
    }

    @media (min-height: 900px) {
      animation-duration: ${({ background }) => `${1.5 * background.speed}s`};
    }
  }
`;


export const MainLink = styled(RouterLink)`
  display: inline-block;
  padding: 0 25px;

  font-weight: 400;
  font-size: 30px;
  line-height: 45px;
  color: ${({ colors }) => colors.text};
  text-decoration: none;

  background-color: ${({ colors }) => colors.background};
  transform: translateY(110%);


  @media (min-height: 500px) {
    font-size: 40px;
    line-height: 72px;
  }
  @media (min-width: 768px) and (min-height: 600px) {
    font-size: 85px;
    line-height: 118px;
  }

  @media (min-width: 1600px) and (min-height: 768px) {
    font-weight: 300;
    font-size: 114px;
    line-height: 150px;
  }

  &:hover, &:focus {
  color: ${({ colors }) => colors.textHover};

  background-color: ${({ colors }) => colors.backgroundHover};
  }
`;


export const SecondaryLink = styled(MainLink)`
  padding: 0 20px;

  font-size: 24px;
  line-height: 36px;


  @media (min-height: 500px) {
    font-size: 30px;
    line-height: 50px;
  }
  @media (min-width: 768px) and (min-height: 600px) {
    font-size: 45px;
    line-height: 68px;
  }

  @media (min-width: 1600px) and (min-height: 768px) {
    font-size: 62px;
    line-height: 82px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/modules/Menu/styled.js